import { apiGet, apiDelete, apiPatch, apiPost, apiPut } from '../common';

function wrappedApiCall(apiCall: typeof apiGet): (url: string, data?: any, namespace?: string) => Promise<any> {
  return (url: string, data?: any, namespace?: string) =>
    new Promise<any>((resolve, reject) => {
      apiCall(url, data, resolve, reject, namespace);
    });
}

const FetchPromise = {
  get: wrappedApiCall(apiGet),
  post: wrappedApiCall(apiPost),
  patch: wrappedApiCall(apiPatch),
  put: wrappedApiCall(apiPut),
  delete: wrappedApiCall(apiDelete),
};

export default FetchPromise;
